import { configureLocalization } from '@lit/localize';

type LocalizeFns = {
  getLocale: () => string;
  setLocale(locale: string): void;
};

function getBaseHrefPathname(): string {
  const url: URL = new URL(document.getElementsByTagName('base')[0].href);
  return url.pathname;
}

function detectLang(baseHref: string): string | undefined {
  const pathname: string = window.location.pathname.endsWith('/')
    ? window.location.pathname
    : window.location.pathname + '/';
  const pathnameFixed: string[] = pathname.replace(baseHref, '').split('/');
  const langSegment: string | undefined = pathnameFixed?.[0];
  return langSegment?.length > 0 ? langSegment : undefined;
}

type EnvWithLangs = {
  langs: string[];
  additionalI18nLangs?: string[];
};

export async function initI18n(
  env: EnvWithLangs,
  loadLocalizeFn: (lang: string) => Promise<Record<string, any>>,
  mapLangToLocalizeLocale?: (lang: string) => string
): Promise<void> {
  const baseHref: string = getBaseHrefPathname();
  const lang: string | undefined = detectLang(baseHref);
  if (lang && !env.langs.includes(lang)) {
    return;
  }
  if (!lang) {
    return;
  }
  const translations: Record<string, string> = await loadLocalizeFn(lang!);
  const functions: LocalizeFns = configureLocalization({
    sourceLocale: 'en',
    targetLocales: [...env.langs, ...(env.additionalI18nLangs ?? [])],
    loadLocale: async () => ({
      templates: translations
    })
  });
  functions.setLocale(mapLangToLocalizeLocale?.(lang!) ?? lang!);
}
